/**
 * @Desription: 排序
 * @Author: netstar.sjj
 * @Date: 2021-09-24 11:05:00
 * @class NSSort
 */
declare const window:any;
namespace NSSort{
    //比较两个值是否数值类型
    const getCompareForNumber = function(value1:any,value2:any){
        //比较两个值 如果不为数值类型 判断是否是字符串可转换的数值格式 如果不是 按空处理
        let type1:string = typeof(value1);
        let type2:string = typeof(value2);
        let value1IsEmpty = false;//值是否为空
        let value2IsEmpty = false;//值是否为空
        switch(type1){
            case 'object':
            case 'undefined':
                value1IsEmpty = true;//不是数值类型就都按空处理
                break;
            case 'string':
                if(value1){
                    value1 = Number(value1);
                    if(isNaN(value1)){
                        //非数值类型的
                        value1IsEmpty = true;
                    }else{
                        type1 = 'number';
                    }
                }else{
                    //值为空
                    value1IsEmpty = true;
                }
                break;
        }
        switch(type2){
            case 'object':
            case 'undefined':
                value2IsEmpty = true;//不是数值类型就都按空处理
                break;
            case 'string':
                if(value2){
                    value2 = Number(value2);
                    if(isNaN(value2)){
                        //非数值类型的
                        value2IsEmpty = true;
                    }else{
                        type2 = 'number';
                    }
                }else{
                    //值为空
                    value2IsEmpty = true;
                }
                break;
        }
        return {
            type1:type1,//值1的类型
            type2:type2,//值2的类型
            value1IsEmpty:value1IsEmpty,//值1是否为空
            value2IsEmpty:value2IsEmpty,//值2是否为空
        }
    }
    //当前字符的等级按类型输出 特殊字符>数字>字母>汉字
    const getCharacterLevel = function(char:any){
        let specialChars = ' !！"#$%&(（)）*,，.。/:：;；?？@[\\【]】^_`{|}~+<=>';
        let numberReg = /\d/g;
        let latinReg = /[A-Za-z]/g;
        let chineseReg = /[\u4e00-\u9fa5]/g;
        let level = 5;
        if (specialChars.includes(char)) {
            level = 1;
        }
        if (numberReg.test(char)) {
            level = 2;
        }
        if (latinReg.test(char)) {
            level = 3;
        }
        if (chineseReg.test(char)) {
            level = 4;
        }
        return level;
    }
    //字符比较
    const compareChar = function(char1:any,char2:any){
        let level1 = getCharacterLevel(char1);
        let level2 = getCharacterLevel(char2);
        if (level1 !== level2) {
            return level1 - level2;
        }
        let specialCharacters = " !！\"#$%&(（)）*,，.。/:：;；?？@\[\\【]】^_`{|}~+<=>";
        if (level1 === 1) {
            return specialCharacters.indexOf(char1) - specialCharacters.indexOf(char2);
        }
        if (level1 === 2) {
            return parseInt(char1) - parseInt(char2);
        }
        let latinCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        if (level1 === 3) {
            return latinCharacters.indexOf(char1) - latinCharacters.indexOf(char2);
        }
        if (level1 ===4) {
            return char1.localeCompare(char2, 'zh');
        }
    }
    //比较两个值的大小按照excel规则
    export function compareValueExcelRules(value1:any,value2:any){
        try{
            value1 = value1.replaceAll('-','');
            value1 = value1.replaceAll('\'','');
            value2 = value2.replaceAll('-','');
            value2 = value2.replaceAll('\'','');
        }catch(error){

        }
        //  undefined 和 其他非空的值比较时, 认为undefined小
        if (value1 === undefined && !!value2) {
            return -1;
        }
        if (value2 === undefined && !!value1) {
            return 1;
        }
        if (typeof(value1) === "string" && typeof (value2) === "string"){
            let charArray1 = value1.split('');
            let charArray2 = value2.split('');
            let minLength = charArray1.length < charArray2.length ? charArray1.length: charArray2.length;
            for(let i = 0; i < minLength; i++){
                if (charArray1[i] === charArray2[i]) {
                    continue;
                }
                return compareChar(charArray1[i],charArray2[i]);//字符比较
            }
            if(charArray1.length !== charArray2.length){
                return charArray1.length - charArray2.length;
            }
            return 0;
        }
        if (value1 < value2) return -1;
        if (value1 > value2) return 1;
        return 0;
    }
    //数值类型
    export function numberType(fieldData:any,sortField:string,sortAction:string){
        //当前比较类型是数值类型，但是要考虑到值为空，当前比较数值不为数值等的情况分析
        switch(sortAction){
            case 'desc':
                //降序
                fieldData.sort(function(obj1:any,obj2:any){
                    let value1:any = sortField ? obj1[sortField] : obj1;
                    let value2:any = sortField ? obj2[sortField] : obj2;
                    let compareObj = getCompareForNumber(value1,value2);
                    let type1:string = compareObj.type1;
                    let type2:string = compareObj.type2;
                    let value1IsEmpty:boolean = compareObj.value1IsEmpty;
                    let value2IsEmpty:boolean = compareObj.value2IsEmpty;
                    if((value1IsEmpty === true) && (value2IsEmpty === true)){
                        //当前要比较的值都为空
                        return 0;
                    }
                    if((value1IsEmpty === true) && (value2IsEmpty === false)){
                        //值1为空，值2不为空
                        return 1;
                    }
                    if((value1IsEmpty === false) && (value2IsEmpty === true)){
                        //值1不为空，值2为空
                        return -1;
                    }
                    if(type1 === 'number' && type2 === 'number'){
                        //两者要比较的值都是数值类型
                        return value2 - value1;
                    }
                    return 0;
                });
                break;
            case 'asc':
                //升序
                fieldData.sort(function(obj1:any,obj2:any){
                    let value1:any = sortField ? obj1[sortField] : obj1;
                    let value2:any = sortField ? obj2[sortField] : obj2;
                    let compareObj = getCompareForNumber(value1,value2);
                    let type1:string = compareObj.type1;
                    let type2:string = compareObj.type2;
                    let value1IsEmpty:boolean = compareObj.value1IsEmpty;
                    let value2IsEmpty:boolean = compareObj.value2IsEmpty;
                    if((value1IsEmpty === true) && (value2IsEmpty === true)){
                        //当前要比较的值都为空
                        return 0;
                    }
                    if((value1IsEmpty === true) && (value2IsEmpty === false)){
                        //值1为空，值2不为空
                        return -1;
                    }
                    if((value1IsEmpty === false) && (value2IsEmpty === true)){
                        //值1不为空，值2为空
                        return 1;
                    }
                    if(type1 === 'number' && type2 === 'number' ){
                        return value1-value2;
                    }
                    return 0;
                });
                break;
        }
    }
    //日期字符串类型
    export function dateType(fieldData:any,sortField:string,sortAction:string){
        switch(sortAction){
            case 'asc':
                fieldData.sort(function(obj1:any,obj2:any){
                    let value1:any = sortField ? obj1[sortField] : obj1;
                    let value2:any = sortField ? obj2[sortField] : obj2;
                    let value1IsValid = window.moment(value1).isValid();
                    let value2IsValid = window.moment(value2).isValid();
                    if((value1IsValid === true) && (value2IsValid === true)){
                        return window.moment(value1).format('x') - window.moment(value2).format('x');
                    }else if((value1IsValid === false) && (value2IsValid === false)){
                        return 0;
                    }else if((value1IsValid === true)){
                        return 1;
                    }else{
                        return -1;
                    }
                })
                break;
            case 'desc':
                fieldData.sort(function(obj1:any,obj2:any){
                    let value1:any = sortField ? obj1[sortField] : obj1;
                    let value2:any = sortField ? obj2[sortField] : obj2;
                    let value1IsValid = window.moment(value1).isValid();
                    let value2IsValid = window.moment(value2).isValid();
                    if((value1IsValid === true) && (value2IsValid === true)){
                        return window.moment(value2).format('x') - window.moment(value1).format('x');
                    }else if((value1IsValid === false) && (value2IsValid === false)){
                        return 0;
                    }else if((value1IsValid === true)){
                        return -1;
                    }else{
                        return 1;
                    }
                })
                break;
            default:
                break;
        }
    }
    //字符串类型
    export function stringType(fieldData:any,sortField:string,sortAction:string,otherOptions){
        let formatData:any = typeof(otherOptions.formatData)=='object' ? otherOptions.formatData : {};
        switch(sortAction){
            case 'desc':
                fieldData.sort(function(obj1:any,obj2:any){
                    let value1:any = formatData[obj1[sortField]] ? formatData[obj1[sortField]] : obj1[sortField];
                    let value2:any = formatData[obj2[sortField]] ? formatData[obj2[sortField]] : obj2[sortField];
                    return 0 - compareValueExcelRules(value1,value2);
                })
                break;
            case 'asc':
                fieldData.sort(function(obj1:any,obj2:any){
                    let value1:any = formatData[obj1[sortField]] ? formatData[obj1[sortField]] : obj1[sortField];
                    let value2:any = formatData[obj2[sortField]] ? formatData[obj2[sortField]] : obj2[sortField];
                    return compareValueExcelRules(value1,value2);
                })
                break;
        }
    }
    //纯字母
    export function letterType(fieldData:any,sortField:string,sortAction:string){
        complexType(fieldData,sortField,sortAction);
    }
    //数字和字母混合
    export function numberMixLetterType(fieldData:any,sortField:string,sortAction:string){
        complexType(fieldData,sortField,sortAction);
    }
    //数字+标点符号+字母+汉字组合
    export function complexType(fieldData:any,sortField:string,sortAction:string){
        switch(sortAction){
            case 'desc':
                fieldData.sort(function(obj1:any,obj2:any){
                    let val1 = sortField ? obj1[sortField] : obj1;
                    let val2 = sortField ? obj2[sortField] : obj2;
                    return 0 - compareValueExcelRules(val1,val2);
                })
                break;
            case 'asc':
                fieldData.sort(function(obj1:any,obj2:any){
                    let val1 = sortField ? obj1[sortField] : obj1;
                    let val2 = sortField ? obj2[sortField] : obj2;
                    return compareValueExcelRules(val1,val2);
                });
                break;
        }
    }
    /**
     * @description 单字段排序
     * @param  {any} fieldData 排序的数据
     * @param {string}sortField 排序字段 
     * @param {string} sortType 排序类型 number(数值类型) letter(纯字母) numberMixLetter(数字和字母混合) complex(数字+标点符号+字母+汉字组合)
     * @param {string}sortAction 排序方式 desc（升序）asc(降序)
     * @param {any} otherOptions 格式化属性配置
    */
    export function singleSort(fieldData:any,sortField:string,sortType:string,sortAction:string,otherOptions?:any){
        switch(sortType){
            case 'number':
                //数值类型
                numberType(fieldData,sortField,sortAction);
                break;
            case 'letter':
                //纯字母
                letterType(fieldData,sortField,sortAction);
                break;
            case 'numberMixLetter':
                //数字和字母混合
                numberMixLetterType(fieldData,sortField,sortAction);
                break;
            case 'string':
                stringType(fieldData,sortField,sortAction,otherOptions);
                break;
            case 'provinceselect':
                break;
            case 'complex':
            default:
                //数字+标点符号+字母+汉字组合
                complexType(fieldData,sortField,sortAction);
                break;
        }
    }
    /**
     * @description 表格列排序
     * @param  {any} fieldData 排序的数据
     * @param {any} options 排序属性配置
     * @param options.sortField 排序字段 允许设置多个
     * @param options.sortAction 排序方式 desc（升序）asc(降序)
     * @param options.sortType 排序类型 如number,date,datetimer,stringReplace,subdataText,htmlRender
     * @param options.formatHandler 列相关格式化参数
    */
    export function gridColumnSort(fieldData:any,options:any){
        let isSort:boolean = true;//默认当前列可以排序
        let sortType:string = options.sortType;//列的排序类型
        let sortField:string = options.sortField;//排序的字段
        let sortAction:string = options.sortAction;//排序方式 desc asc
        let formatHandler:any = typeof(options.formatHandler)=='object' ? options.formatHandler : {};
        options.formatData = {};
        /***********读取当前要排序列的类型 如果当前列类型不符合排序则不参与 start******************* */
        switch(sortType){
            case 'thumb':
            case 'func':
            case 'htmlRender':
            case 'showFileByType':
            case 'tagsManage':
            case 'standardInput':
            case 'downloadFile':
            case 'cubesInput':
            case 'buildPdf':
            case 'upload':
            case 'signAndPdf':
            case 'href':
            case 'columnstate':
            case 'multidate':
            case 'renderField':
                isSort = false;//当前列字段不参与排序
                break;
        }
        /***********读取当前要排序列的类型 如果当前列类型不符合排序则不参与 end******************* */
        if(isSort === true){
            /***********根据输出类型决定当前排序方式的支持和值的转换 start************************ */
            switch(sortType){
                case 'timeUnit':
                case 'diffUnit':
                case 'date':
                case 'datetimer':
                    //日期类型的输出都是时间戳的格式，可以当成数字去处理  
                    sortType = 'number';
                    break;
                case 'money':
                case 'money-href':
                    //金钱类型的额输出都是数字，可以当做数字去处理
                    sortType = 'number';
                    break;
                case 'subdataText':
                    if(typeof(formatHandler.data)=='object'){
                        if(typeof(formatHandler.data.formatDate) == "object"){
						    options.formatData = formatHandler.data.formatDate;
                        }
					}
                    sortType = 'string';
                    break;
                case 'dictionary':
                    options.formatData = typeof(formatHandler.data)=='object' ? formatHandler.data : {};
                    sortType = 'string';
                    break;
                case 'stringReplace':
                    //下拉 字典 字符串替换
                    options.formatData = formatHandler.data;
					if(typeof(options.formatData.formatDate) == "object"){
						options.formatData = options.formatData.formatDate;
					}
                    sortType = 'string';
                    break;
                case 'codeToName':
                    //省市区
                    sortType = 'provinceselect';
                    break;
            }
            /***********根据输出类型决定当前排序方式的支持和值的转换 start************************ */
            if(sortField.indexOf(',')>-1){
                //多个字段排序
            }else{
                //单字段排序
                singleSort(fieldData,sortField,sortType,sortAction,options);
            }
        }else{
            console.warn(options);
        }
    }
    
    export function oneDimensionArray(dataArray,dataType,sortType){
        /**
         * dataArray 需要排序的数据
         * sortType 排序类型 asc（升序） desc(降序)
         * dataType 数据类型 date(日期) string(字符串) number(数字) complex(excel表格的规则排序)
        */
        switch(dataType){
            case 'number':
                numberType(dataArray,'',sortType);
                break;
            case 'date':
                dateType(dataArray,'',sortType);
                break;
            default:
                complexType(dataArray,'',sortType);
        }
    }
}
export default NSSort;